import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { DialogModule } from 'primeng/dialog';
import { TextareaModule } from 'primeng/textarea';

import { AppButtonComponent } from '@shared/components/app-button/app-button.component';
import { FaqEditItem } from '../spu-faq-editor/spu-faq.model';

export type FaqDialogResult = Pick<
  FaqEditItem,
  'questionVi' | 'answerVi' | 'questionEn' | 'answerEn'
>;

@Component({
  selector: 'app-spu-faq-dialog',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslateModule,
    DialogModule,
    TextareaModule,
    AppButtonComponent,
  ],
  templateUrl: './spu-faq-dialog.component.html',
  styleUrl: './spu-faq-dialog.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpuFaqDialogComponent implements OnChanges {
  @Input() visible = false;
  @Input() initialData: FaqEditItem | null = null;
  @Input() viewMode = false;
  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() confirm = new EventEmitter<FaqDialogResult>();

  faqForm: FormGroup;

  constructor(private readonly fb: FormBuilder) {
    this.faqForm = this.buildForm();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['initialData'] || changes['visible']) {
      this.faqForm = this.buildForm(this.initialData);
    }
  }

  private buildForm(data: FaqEditItem | null = null): FormGroup {
    return this.fb.group({
      questionVi: [data?.questionVi ?? '', Validators.required],
      answerVi: [data?.answerVi ?? '', Validators.required],
      questionEn: [data?.questionEn ?? ''],
      answerEn: [data?.answerEn ?? ''],
    });
  }

  onCancel(): void {
    this.visibleChange.emit(false);
  }

  onConfirm(): void {
    if (this.faqForm.invalid) {
      this.faqForm.markAllAsTouched();
      return;
    }
    this.confirm.emit(this.faqForm.value as FaqDialogResult);
    this.visibleChange.emit(false);
  }
}
